import React, { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Toolbar } from "primereact/toolbar";
import { ApproveSubmissionForm } from "./ApproveSubmissionForm";
import { Form } from "../trainingScheduler/Form";
import { MultiTrainingSchedulerForm } from "./MultiTrainingSchedulerForm";

export interface ITrainingForm {
    form_ID?: number,
    formOf?: string,
    formOfLogin_ID?: number,
    topic_ID?: number,
    topic_Name?: string,
    category_ID?: number,
    category_Name?: string,
    trainer_ID?: number,
    trainer_Login_ID?: number,
    trainer_Name?: string,
    form_Status?: number,
    rejection_Comment?: string,
    added_By?: string,
    added_On?: Date,
    updated_By?: string,
    updated_On?: Date,
    status_Action_By?: string,
    status_Action_On?: Date,
    userManual_Path?: string,
    document_Path?: string,
}

interface IProps {
    setModal: (modal: { open: boolean, singleData: ITrainingForm }) => void,
    reload: boolean,
    permission: IPermissionProps,
    toast: any,
    reloadTable: () => void,
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ITrainingForm[], loading: boolean });
    const [openRejection, setOpenRejection] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITrainingForm });
    const [openAprvForm, setOpenAprvForm] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITrainingForm });
    const [openSchedulerForm, setOpenSchedulerForm] = useState({ open: false, singleData: {} } as { open: boolean, singleData: any });
    const [openMultiAprvForm, setOpenMultiAprvForm] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITrainingForm });
    const dt = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const header = () => {
        return <p>Training Forms</p>
    }

    const addDate = (rowData: ITrainingForm) => {
        let date;
        if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const updateDate = (rowData: ITrainingForm) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const statusDate = (rowData: ITrainingForm) => {
        let date;
        if (rowData.status_Action_On) date = format(new Date(rowData.status_Action_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const approveStatus = (rowData: ITrainingForm) => {
        return (<p className="cursor-pointer underline" style={{ color: rowData.form_Status === 2 ? "red" : (rowData.form_Status === 1 ? "green" : (rowData.form_Status === 3 ? "blue" : "black")) }} onClick={() => {
            if ((rowData.form_Status === null || rowData.form_Status === 0) && (_roles.includes(1) || _roles.includes(26) || _roles.includes(48))) {
                setOpenAprvForm({ open: true, singleData: rowData });
            }
            if (rowData.form_Status === 2) {
                setOpenRejection({ open: true, singleData: rowData });
            }
            if (rowData.form_Status === 1 && (_roles.includes(1) || _roles.includes(26) || _roles.includes(48))) {
                // const data = {
                //     form_ID: rowData.form_ID,
                //     no_Of_Trainees: 0,
                //     branchName: "",
                //     training_Date_From: new Date(),
                //     training_Date_To: new Date(),
                //     training_Time_From: new Date(),
                //     training_Time_To: new Date(),
                // };
                // setOpenSchedulerForm({ open: true, singleData: data });
                setOpenMultiAprvForm({ open: true, singleData: rowData });
            }
            if (rowData.form_Status === 3 && (_roles.includes(1) || _roles.includes(26) || _roles.includes(48))) {
                setOpenMultiAprvForm({ open: true, singleData: rowData });
            }
        }}>{rowData.form_Status === 1 ? "Approved" : (rowData.form_Status === 2 ? "Rejected" : (rowData.form_Status === 3 ? "scheduled" : "Pending"))}</p>);
    };

    const openEdit = (data: ITrainingForm) => props.setModal({ open: true, singleData: { form_ID: data.form_ID, category_ID: data.category_ID, topic_ID: data.topic_ID } });

    const action = (rowData: ITrainingForm) => {
        return (
            <div className="flex gap-3">
                {(rowData.form_Status != 1 || (_roles.includes(1) || _roles.includes(26))) && ((props.permission.is_Update || (_roles.includes(1) || _roles.includes(26))) ? <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button> : <></>)}
            </div>
        );
    };

    const openNew = () => {
        props.setModal({ open: true, singleData: { category_ID: 0, topic_ID: 0 } });
    };

    const leftToolbarTemplate = () => {
        return (

            <React.Fragment>
                <div className="my-2">
                    {(props.permission.is_Create || (_roles.includes(1) || _roles.includes(26))) && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />}
                </div>
            </React.Fragment>
        );
    };

    const downLoadUserManual = async (rowData: ITrainingForm) => {
        const params = {
            method: "GET",
            headers: {
                //'Content-Type': 'application/pdf',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"CarnivalTraining/downloadFile"}?form_ID=${rowData.form_ID}&path=${rowData.userManual_Path}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${rowData.form_ID}_${rowData.trainer_Name}_UserManual.${rowData.userManual_Path?.split(".")[1]}`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    };

    const downLoadSupportiveDocs = async (rowData: ITrainingForm) => {
        const params = {
            method: "GET",
            headers: {
                //'Content-Type': 'application/pdf',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"CarnivalTraining/downloadFile"}?form_ID=${rowData.form_ID}&path=${rowData.document_Path}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${rowData.form_ID}_${rowData.trainer_Name}_SupportiveDocumnet.${rowData.document_Path?.split(".")[1]}`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("CarnivalTraining/getTrainerSubmissionForm", "GET", null, null, props.toast);
        if (response) {
            const data: ITrainingForm[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                lazy dataKey="form_ID"
                emptyMessage="No Record found."
                value={tableData.tableData} loading={tableData.loading}
                header={header}>
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="trainer_Name" header="Trainer" />
                <Column field="topic_Name" header="Topic" />
                <Column field="category_Name" header="Category" />
                <Column field="form_Status" header="Status" body={(rowData: ITrainingForm) => approveStatus(rowData)} />
                <Column field="status_Action_By" header="Status By" />
                <Column field="added_On" header="Added On" body={(rowData: ITrainingForm) => addDate(rowData)} />
                <Column field="added_By" header="Added By" />
                <Column field="updated_On" header="Updated On" body={(rowData: ITrainingForm) => updateDate(rowData)} />
                <Column field="updated_By" header="Updated By" />
                {/* <Column field="status_Action_On" header="status_Action_On" body={(rowData: ITrainingForm) => statusDate(rowData)} /> */}
                <Column field="userManual_Path" header="User Manual" body={(rowData: ITrainingForm) => <p className="cursor-pointer text-primary underline" onClick={() => downLoadUserManual(rowData)}>Download</p>} />
                <Column field="document_Path" header="Supportive Document" body={(rowData: ITrainingForm) => <p className="cursor-pointer text-primary underline" onClick={() => downLoadSupportiveDocs(rowData)}>Download</p>} />
                <Column header="Action" body={action} />
            </DataTable>
            <Dialog visible={openRejection.open} style={{ width: '50vw' }} header="Rejection Reason" modal className="p-fluid" onHide={() => setOpenRejection({ open: false, singleData: {} })}>
                <Card>
                    <div>{openRejection.singleData.rejection_Comment}</div>
                    {(_roles.includes(1) || _roles.includes(26)) && <div>
                        <div className="w-full flex gap-3 flex-row-reverse mt-2">
                            {openRejection.singleData.form_Status === 2 && <Button style={{ width: '100px' }} label="Approve" onClick={() => {
                                setOpenRejection({ open: false, singleData: {} });
                                setOpenAprvForm({ open: true, singleData: openRejection.singleData });
                            }} type="button"></Button>}
                        </div>
                    </div>}
                </Card>
            </Dialog>
            <ApproveSubmissionForm open={openAprvForm.open} singleData={openAprvForm.singleData} toast={props.toast} hideDialog={() => setOpenAprvForm({ open: false, singleData: {} })} reloadTable={() => props.reloadTable()} />
            <Form open={openSchedulerForm.open} singleData={openSchedulerForm.singleData} hideDialog={() => setOpenSchedulerForm({ open: false, singleData: {} })} toast={props.toast} reloadTable={() => { }} />
            <MultiTrainingSchedulerForm open={openMultiAprvForm.open} singleData={openMultiAprvForm.singleData} form_ID={openMultiAprvForm.singleData?.form_ID || 0} hideDialog={() => setOpenMultiAprvForm({ open: false, singleData: {} })} toast={props.toast} />
        </>
    );
}